import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../../home/selectors'
import { IPcr } from '../../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../../user/selectors'
import { saveLabs } from '../store/labs.actions'
import { LabsConstants } from '../store/labs.constants'
import { ILabsState } from '../store/labs.types'
import { getLabsSelector } from '../selectors/labs.selector'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'

export function* setComments() {
  const labsState: ILabsState = yield select(getLabsSelector)
  const { comments } = labsState
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    if (pcrDoc.patient?.labsStateList && pcrDoc.patient?.labsStateList.length) {
      const index = pcrDoc.patient?.labsStateList?.findIndex((labs) => labs.key === labsState.key)
      if (index !== -1) {
        if (pcrDoc.patient.labsStateList[index].comments !== comments) {
          yield put(saveLabs())
        }
      }
    } else {
      yield put(saveLabs())
    }
  } else {
    // todo: add to audit log
  }
}

export function* setCommentsSaga() {
  yield takeLatest([LabsConstants.SET_COMMENTS], performWithMutexHOG, setComments)
}
